import React from 'react'
import { Modal, ModalKind } from '@aposphaere/ui-components'
import { useModal } from '../../contexts/modalContext'
import { usePharmacyInfoHtmlQuery } from '../../hooks/graphql'

type Props = {
  pharmacyId: number
}

const PharmacyInfoModal: React.FC<Props> = ({ pharmacyId }) => {
  const { data: htmlBlocks, isLoading } = usePharmacyInfoHtmlQuery(pharmacyId)
  const { closeModal } = useModal()

  return (
    <Modal kind={ModalKind.sm} title="Apotheke Info" onClose={closeModal} onBack={() => null}>
      {isLoading && <div>Lade Daten…</div>}

      {!isLoading && htmlBlocks?.length === 0 && <div className="p-6">Keine Informationen vorhanden</div>}

      {!isLoading &&
        htmlBlocks?.map((html, index) => (
          <div key={index} className="w-full" style={{ marginBottom: 16 }} dangerouslySetInnerHTML={{ __html: html }} />
        ))}
    </Modal>
  )
}

export default PharmacyInfoModal
